module.exports = __webpack_public_path__ + "img/logo.b6a8687.png";